import api from "../services/api";
import { APIS } from "../endpoints";

/**
 * This function return songs data
 * @returns {Promise<Object>} - Function return Songs data
 */

// export const getArchiveData = async (limit, page) => {
//     const response = await getArchiveAPIData(limit, page);
//     return response;
// };

// Returns true when the filter payload has no user-applied selections.
// Backend treats any non-empty `filters` query param as a filtered query and
// returns an empty result, so we OMIT the param entirely on initial loads
// (default state: empty filters object + default sortBy_v + empty search).
const _isDefaultFilterOptions = (opts) => {
  if (!opts || typeof opts !== "object") return true;
  const filters = opts.filters;
  const hasFilterValues =
    filters &&
    typeof filters === "object" &&
    Object.values(filters).some((v) =>
      Array.isArray(v) ? v.length > 0 : Boolean(v),
    );
  if (hasFilterValues) return false;
  if (opts.search) return false;
  return true;
};

export const getAllPostsData = async (
  limit,
  page,
  searchTerm,
  filterOptions = {},
) => {
  const formData = new FormData();
  formData.append("page", page);
  formData.append("limit", limit);

  if (!_isDefaultFilterOptions(filterOptions)) {
    const cleanedOptions = {
      ...filterOptions,
      filters: Object.fromEntries(
        Object.entries(filterOptions.filters || {}).filter(([, v]) =>
          Array.isArray(v) ? v.length > 0 : Boolean(v),
        ),
      ),
    };
    formData.append("filters", JSON.stringify(cleanedOptions));
  }

  if (searchTerm) {
    formData.append("search", searchTerm);
  }

  if (filterOptions?.sortBy_v) {
    const sortKey = filterOptions.sortBy_v;
    if (sortKey.endsWith("_desc")) {
      formData.append("sort_by", sortKey.slice(0, -5));
      formData.append("sort_order", "desc");
    } else {
      formData.append("sort_by", sortKey);
      formData.append("sort_order", "asc");
    }
  }

  const params = new URLSearchParams(formData);
  const result = await api.get(`${APIS.BASE_URL}${APIS.posts}`, {
    params: params,
  });

  if (result) {
    return result?.data;
  } else {
    return [];
  }
};

export const getPostData = async (alias) => {
  // Construct the endpoint URL conditionally based on the presence of `section`
  const endpoint = `${APIS.BASE_URL}admin/posts/${alias}`;

  try {
    const result = await api.get(endpoint);

    // Return the `data` if the result exists, otherwise return an empty array
    return result?.data?.data || [];
  } catch (error) {
    console.error("Error fetching libraries data:", error);
    return [];
  }
};

export const updatePostData = async (alias, data, deletedValues) => {
  const payload = {
    ...data,
    deletedValues: deletedValues,
  };

  const result = await api.put(`${APIS.BASE_URL}admin/posts/${alias}`, payload);

  if (result) {
    return result?.data;
  } else {
    return [];
  }
};

export const createNewPost = async (data) => {
  const result = await api.post(`${APIS.BASE_URL}admin/posts`, data);

  if (result) {
    return result?.data;
  } else {
    return [];
  }
};

export const deletePostsData = async (deletedItems) => {
  const result = await api.delete(`${APIS.BASE_URL}${APIS.posts}`, {
    data: { deletedItems },
  });
  if (result) {
    return result?.data;
  } else {
    return [];
  }
};

/**
 * This function returns masterlist keywords autocomplete data
 * @param {string} searchTerm - Search term for autocomplete
 * @returns {Promise<Array>} - Function returns masterlist keywords data
 */
export const getMasterlistKeywordsAutocomplete = async (searchTerm) => {
  try {
    const result = await api.get(
      `${APIS.BASE_URL}search/keywords/autocomplete?search=${searchTerm}`,
    );
    if (result) {
      return result?.data;
    }
    return [];
  } catch (error) {
    console.error("Error fetching masterlist keywords autocomplete:", error);
    return [];
  }
};
